export default function () {
  return {
    items: [],
    recommended: [],
    pagination: [],
    item: {}
  };
}